import { TRoundButtonSize } from '@cian/ui-kit/button/types/TButtonSize';
import * as React from 'react';

import { useCallbackButton } from './useCallbackButton';
import { CallbackButton, CallbackButtonCollapsed } from '../../components/CallbackButton';
import { TCallbackOpener } from '../../types/callbackPopup';

interface ICallBackButtonContainerProps {
  size?: TRoundButtonSize;
  collapsed?: boolean;
  placeType: TCallbackOpener;
}

export function CallBackButtonContainer({ size = 'M', collapsed, placeType }: ICallBackButtonContainerProps) {
  const [isCallbackAvailable, handleCallbackButtonClick] = useCallbackButton(placeType);

  if (!isCallbackAvailable) {
    return null;
  }

  const ButtonComponent = collapsed ? CallbackButtonCollapsed : CallbackButton;

  return <ButtonComponent size={size} onClick={handleCallbackButtonClick} />;
}
